const namespaces = {
    "https://grafsync.graphifi.com/schema/gs/": "gs",
    "http://www.w3.org/2001/XMLSchema#": "xsd",
    "http://www.w3.org/2004/02/skos/core#": "skos",
    "http://www.w3.org/2008/05/skos-xl#": "skosxl",
    "http://purl.org/dc/terms/": "dct",
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#": "rdf",
    "http://www.w3.org/2000/01/rdf-schema#": "rdfs",
    "http://www.w3.org/2002/07/owl#": "owl",
    "https://grafsync.graphifi.com/schema/vm/": "vm",
    "https://graphifi.com/schema/xkos/": "xkos",
    "https://grafsync.graphifi.com/schema/om-entitlement/": "ome",
    "https://grafsync.graphifi.com/schema/vm-entitlement/": "vme",
    "https://graphifi.com/schema/accesscontrol/": "acl",
    "https://graphifi.com/schema/entitlement/": "ent",
    "https://graphifi.com/schema/scope/": "scp",
    "https://graphifi.com/schema/xowl/": "xowl"
};

export default namespaces;